import { Button, Checkbox, Drawer, Form, Input, message, Select, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { useClientsServiceGetBackendClients, useOutputFormatsServicePutBackendOutputformats } from '../../../backendapi/queries';
import { OutputFormatDTO, OutputFormatEditDTO } from '../../../backendapi/requests';

const EditOutputFormat: React.FC<{ outputFormat?: OutputFormatDTO, isOpen: boolean, onClose: () => void }> = ({ outputFormat, isOpen, onClose }) => {
    const { data: clients } = useClientsServiceGetBackendClients({}, undefined, { enabled: isOpen });

    const { mutateAsync } = useOutputFormatsServicePutBackendOutputformats();


    const [form] = Form.useForm<OutputFormatEditDTO>();
    const [messageApi, contextHolder] = message.useMessage();
    const [saving, setSaving] = useState(false);

    const onSubmit = () => {
        form.submit();
    }

    const onFinish = () => {
        if (outputFormat) {
            setSaving(true);

            const values = form.getFieldsValue(true) as OutputFormatEditDTO;

            mutateAsync({ key: outputFormat.id, requestBody: values }).then(() => {
                messageApi.success("Output format updated");
                setSaving(false);
                onClose();
            }).catch(() => {
                messageApi.error("An error occured");
                setSaving(false);
            });
        }
    };

    useEffect(() => {
        if (outputFormat) {
            form.resetFields();
            form.setFieldsValue(outputFormat);
        }
    }, [outputFormat, form])

    return (
        <>
            {contextHolder}

            <Drawer
                title={`Edit ${outputFormat?.title}`}
                width={720}
                onClose={onClose}
                open={isOpen}
                bodyStyle={{ paddingBottom: 80 }}
                extra={
                    <Space>
                        <Button onClick={onClose}>Cancel</Button>
                        <Button onClick={onSubmit} type="primary" loading={saving}>
                            Submit
                        </Button>
                    </Space>
                }
            >
                <Form
                    name="basic"
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}>

                    <Form.Item rules={[{ required: true }]} name='clientId' label="Client">
                        <Select options={clients?.value.map(e => ({ label: e.name, value: e.id }))} />
                    </Form.Item>

                    <Form.Item rules={[{ required: true }]} name={'title'} label="Title">
                        <Input />
                    </Form.Item>

                    <Form.Item rules={[{ required: true }]} name={'name'} label="Name">
                        <Input />
                    </Form.Item>

                    <Form.Item name="isEnabled" valuePropName="checked">
                        <Checkbox>Enabled</Checkbox>
                    </Form.Item>

                    <Form.Item name="isDefault" valuePropName="checked">
                        <Checkbox>Default</Checkbox>
                    </Form.Item>

                    <Form.Item name="isStillFormat" valuePropName="checked">
                        <Checkbox>Still Format</Checkbox>
                    </Form.Item>

                    <Form.Item name="isAnimationFormat" valuePropName="checked">
                        <Checkbox>Animation Format</Checkbox>
                    </Form.Item>

                    <Form.Item name="filetype" label='File type'>
                        <Select options={[
                            { value: 'jpg', label: 'jpg' },
                            { value: 'png', label: 'png' }
                        ]} />
                    </Form.Item>

                    <Form.Item label="Size" style={{ marginBottom: 0 }}>
                        <Form.Item
                            rules={[{ required: true }]}
                            name={'width'}
                            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                            label="Width">
                            <Input />
                        </Form.Item>

                        <Form.Item
                            rules={[{ required: true }]}
                            name={'height'}
                            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                            label="Height">
                            <Input />
                        </Form.Item>
                    </Form.Item>

                    <Form.Item label="Preview Size" style={{ marginBottom: 0 }}>
                        <Form.Item
                            rules={[{ required: true }]}
                            name={'previewWidth'}
                            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                            label="Width">
                            <Input />
                        </Form.Item>

                        <Form.Item
                            rules={[{ required: true }]}
                            name={'previewHeight'}
                            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                            label="Height">
                            <Input />
                        </Form.Item>
                    </Form.Item>


                </Form>
            </Drawer>
        </>

    );
};

export default EditOutputFormat;